export default __webpack_public_path__ + "static/media/022-guitar.aa077654.svg";